import { render, staticRenderFns } from "./BpcPageTitle.vue?vue&type=template&id=9abcccae&"
import script from "./BpcPageTitle.vue?vue&type=script&lang=js&"
export * from "./BpcPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./BpcPageTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports